import React from "react";
import { Button } from "aible";
import { useDispatch } from "types/store";
import { updateIsShowModal } from "containers/SchemaMonitor/reducer";
import AWSIconSmall from "images/aws-brands-1.svg";
import AzureIconSmall from "images/microsoft-azureicon-seeklogo-1.svg";
import OracleIconSmall from "images/Oracle-1.svg";
import SnowflakeIconSmall from "images/Snowflake-1.svg";
import GCPIcon from "images/gcp.svg";
import SalesforceIcon from "images/G/Salesforce.svg";
import DataBricksIcon from "images/EDG/DB/databricks.png";
import styles from "./style.module.css";
const iconHeightSmall = "17px";
const ConnectDataWarehouseButton = () => {
    const dispatch = useDispatch();
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: styles.uButton, style: {
                marginRight: "10px",
                padding: "10px 12px"
            }, onClick: () => dispatch(updateIsShowModal(true)), isThinText: true },
            "Link to Data Warehouse",
            React.createElement("div", { className: styles.iconsBarButton },
                React.createElement("div", { className: styles.cIconSmall },
                    React.createElement("img", { src: GCPIcon, style: {
                            maxHeight: iconHeightSmall
                        } })),
                React.createElement("div", { className: styles.cIconSmall },
                    React.createElement("img", { src: SalesforceIcon, style: {
                            maxHeight: iconHeightSmall
                        } })),
                React.createElement("div", { className: styles.cIconSmall },
                    React.createElement("img", { src: AWSIconSmall, style: {
                            maxHeight: iconHeightSmall,
                            marginLeft: "2px"
                        } })),
                React.createElement("div", { className: styles.cIconSmall },
                    React.createElement("img", { src: AzureIconSmall, style: {
                            maxHeight: iconHeightSmall
                        } })),
                React.createElement("div", { className: styles.cIconSmall },
                    React.createElement("img", { src: DataBricksIcon, style: {
                            maxHeight: iconHeightSmall
                        } })),
                React.createElement("div", { className: styles.cIconSmall },
                    React.createElement("img", { src: SnowflakeIconSmall, style: {
                            maxHeight: iconHeightSmall
                        } })),
                React.createElement("div", { className: styles.cIconSmall },
                    React.createElement("img", { src: OracleIconSmall, style: {
                            maxHeight: "16px"
                        } }))))));
};
export default ConnectDataWarehouseButton;
